import { ReactNode } from 'react';
import { useLocalStorage } from '../../../hooks/useLocalStorage';
import { EventSections } from '../../../lib/events/EventLogger';
import DraggableMenu from '../../downloads/DraggableMenu';
import { iProps } from './SmartSendFilterBar';
import Sort from './Sort';
import { useAnalytics } from '@parcel2go/npm-p2g-app';
import { GenerateBaseAnalyticsPayload } from '~/lib/utils/analytics';

interface props extends iProps {
  control: ReactNode;
}

const DraggableSort: React.FC<props> = (props) => {
  const [detached, setDetached] = useLocalStorage<boolean>('sortIsOpen', false);
  const { track } = useAnalytics();

  const onPin = () => {
    setDetached(true);
    track({
      type: 'draggable_sort_pinned',
      payload: {
        ...GenerateBaseAnalyticsPayload([EventSections.SmartSend, EventSections.QuickActions, 'filter'])
      }
    });
  };

  const onUnPinned = () => {
    setDetached(false);
    track({
      type: 'draggable_sort_unpinned',
      payload: {
        ...GenerateBaseAnalyticsPayload([EventSections.SmartSend, EventSections.QuickActions, 'filter'])
      }
    });
  };

  const onContentShow = () => {
    track({
      type: 'draggable_sort_opened',
      payload: {
        ...GenerateBaseAnalyticsPayload([EventSections.SmartSend, EventSections.QuickActions, 'filter'])
      }
    });
  };

  return (
    <DraggableMenu
      detached={detached}
      onPinned={onPin}
      onUnPinned={onUnPinned}
      onContentShow={onContentShow}
      palette="primary"
      id="Sort"
      classNames="btn-sort"
      title="Sort"
      width="350px"
      control={props.control}
    >
      <Sort actions={props.actions} filter={props.filter} update={props.update} isXs={props.isXs}></Sort>
    </DraggableMenu>
  );
};
export default DraggableSort;
